var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResolution1080P = function SvgResolution1080P(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.01,
    d: "M9.625 15.075h1.25V12.85h2v2.225h1.25v-6.15h-1.25V11.6h-2V8.925h-1.25zm5.5 0h3.25q.5 0 .875-.375c.375-.375.375-.542.375-.875v-3.65q0-.5-.375-.875c-.375-.375-.542-.375-.875-.375h-3.25zm1.25-1.25v-3.65h2v3.65zm-12 1.25h1.25V12.85h2.5V11.6h-2.5v-1.425h3v-1.25h-4.25zM2.5 20q-.6 0-1.05-.45T1 18.5v-13q0-.6.45-1.05T2.5 4h19q.62 0 1.06.45T23 5.5v13q0 .6-.44 1.05T21.5 20zm0-1.5h19v-13h-19z"
  })));
};
export default SvgResolution1080P;